
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api';
@Component
export default class Detail extends Vue {
  id: any = '';
  obj: any = {};
  async mounted() {
    this.id = this.$route.query.id;
    const res: any = await getDetail(this.id);
    this.obj = res.data;
  }
}
